module.exports = __webpack_public_path__ + "static/media/property_image_gallery.7d8cc02e.png";